module.exports = __webpack_public_path__ + "img/round3.ae83f7d1.png";